import { defineMessages } from "react-intl";
const messages = defineMessages({
    spacePublishToGMBSuccess: {
        id: "app.spaces.actions.publishToGMB.success.text",
        defaultMessage: "Your unit is in the process of being uploaded to Google My Business. It may take up to 4 days to become fully visible in Street View. For more information, please refer to the <link>FAQ</link>",
    },
    spacePublishToGMBTitle: {
        id: "app.spaces.actions.publishToGMB.title.text",
        defaultMessage: "Publish to Google My Business",
    },
    spacePublishToGMBButton: {
        id: "app.spaces.actions.publishToGMB.button.text",
        defaultMessage: "Publish to Google My Business",
    },
    spacePublishToGMBNextButton: {
        id: "app.spaces.actions.publishToGMB.next.button.text",
        defaultMessage: "Next",
    },
    spacePublishToGMBFormPropertySelector: {
        id: "app.spaces.actions.publishToGMB.form.propertySelector.text",
        defaultMessage: "Select Your Community",
    },
    spacePublishToGMBFormStaged: {
        id: "app.spaces.actions.publishToGMB.form.staged.text",
        defaultMessage: "Publish Staged",
    },
    spacePublishToGMBFormConfimation: {
        id: "app.spaces.actions.publishToGMB.form.confirm.text",
        defaultMessage: "Are you sure you want to publish this property to Google My Business?",
    },
    spacePublishToGMBAuthDescription: {
        id: "app.spaces.actions.publishToGMB.auth.description.text",
        defaultMessage: "  Please proceed with Google Authentication. Make sure to check both boxes to permission Peek for GMB. Failing to do so will result in error.",
    },
    spacePublishToGMBAuthErrorDescription1: {
        id: "app.spaces.actions.publishToGMB.auth.error.description.text",
        defaultMessage: "Your Google account permissions are not set up correctly for Peek to publish to GMB. Please remove PeekGMB from your Google access via this {GoogleAccessLink}. When you reconnect to your GMB account and make sure to check both of the permission boxes.",
    },
    spacePublishToGMBAuthErrorGoogleAccessLink: {
        id: "app.spaces.actions.publishToGMB.auth.error.googleAccessLink.text",
        defaultMessage: "link",
    },
    spacePublishToGMBAuthErrorDescription2: {
        id: "app.spaces.actions.publishToGMB.auth.error.description.text",
        defaultMessage: "Please note, GMB accounts can't be shared between Peek Users.",
    },
});
export default messages;
